import React from 'react';
import { Helmet } from 'react-helmet';

const Seo = ({
  title,
  description,
  keywords = [],
  author,
  url,
  image,
  twitterHandle
}) => {
  return (
    <Helmet>
      {/* Basic SEO Tags */}
      <title>{title}</title>
      <meta name="google-site-verification" content="WqTZfqB29915t0Ehz8KT3j6g7PMjzNDmVUsn15mMmRE" />
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      {author && <meta name="author" content={author} />}
      <link rel="canonical" href={url || 'https://shakilhossain.vercel.app'} />

      {/* Open Graph Tags for Social Media Sharing */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url || 'https://devshakilh.vercel.app'} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:image:alt" content={description} />
      <meta property="og:site_name" content="Md Shakil Hossain Portfolio" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {twitterHandle && <meta name="twitter:site" content={`@${twitterHandle}`} />}
      {twitterHandle && <meta name="twitter:creator" content={`@${twitterHandle}`} />}

      {/* Additional Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
  );
};

export default Seo;
